import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Layout from "../assets/images/certificate.png";
import { useEffect, useState } from "react";
import {
  formatDateWithCurrentYear,
  FormatEndDate,
  getCertificateData,
} from "../utils/constants";
import { useNavigate, useParams } from "react-router-dom";
import UserService from "../services/user.service";
import { toast } from "react-toastify";

const PreviewDownloadCertificate = () => {
  const [clicked, setClicked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>({});
  const navigate = useNavigate();
  const userService = new UserService();
  const { id } = useParams();

  useEffect(() => {
    getProgram();
    setClicked(true);
  }, []);

  const getProgram = async () => {
    setLoading(true);
    try {
      const response = await userService.getProgramsCertificateData(Number(id));
      setLoading(false);
      if (!response.status) {
        return;
      }
      const data = response.data;
      const CertificateData = {
        name: data.child.firstName + " " + data.child.lastName,
        title: data.child.curriculum === 1 ? data.package.name : !data.package.nameOld ? data.package.name : data.package.nameOld,
        date: FormatEndDate(data.endClassDate),
        status: data?.reports[data?.reports.length - 1]?.cohortCompleted,
      };
      setData(CertificateData);
    } catch (err) {
      setLoading(false);
      return;
    }
  };

  // Helper function to get current date as string
  const getCurrentDateString = () => {
    return new Date().toISOString().split('T')[0];
  };

  const downloadPdf = async () => {
    const element = document.getElementById("certificate-download-container");
    if (!element) {
      toast.error("Unable to generate certificate");
      return;
    }

    try {
      toast.warning("Downloading......");
      const captureWidth = Math.round(element.getBoundingClientRect().width);
      const captureHeight = Math.round(element.getBoundingClientRect().height);

      const canvas = await html2canvas(element, {
        scale: 3,
        useCORS: true,
        backgroundColor: "#ffffff",
        logging: false,
        width: captureWidth,
        height: captureHeight,
        windowWidth: captureWidth,
        windowHeight: captureHeight,
      } as any);

      const imgData = canvas.toDataURL("image/png", 1.0);
      const pdf = new jsPDF("landscape", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight, undefined, "FAST");
      pdf.save(`${data.name || "certificate"}-${data.title || "download"}.pdf`);
    } catch (error) {
      toast.error("Failed to generate PDF");
    }
  };

  const renderCertificate = (containerId?: string, fixedForDownload = false) => {
    return (
      <div
        id={containerId}
        className={`certificate-wrapper ${
          fixedForDownload ? "certificate-fixed-render certificate-export-mode" : ""
        }`}
        aria-hidden={fixedForDownload}
      >
        <div className="certificate">
          <img src={Layout} className="certificate-background" alt="Certificate Background" />
          <div className="certificate-content">
            <h2 className="certificate-name">{data.name || "Recipient Name"}</h2>
            <h1 className="certificate-title">
              <b>{data.title || "Course Title"}</b>
            </h1>
            <div className="certificate-date">
              <b>{data.date || formatDateWithCurrentYear(getCurrentDateString())}</b>
            </div>
          </div>
        </div>
      </div>
    );
  };
  
  return (
    <>{data.status ? <>
      <center>
        <button
          className="m-5 flex items-center gap-x-2 px-5 py-3 text-[14px] rounded-[10px] hover:cursor-pointer bg-ryd-primary text-white"
          onClick={downloadPdf}
          disabled={loading}
        >
          {loading ? "Loading..." : "Download as PDF"}
        </button>
      </center>

      <div className="certificate-preview-shell">
        {renderCertificate("certificate-container")}
      </div> </> : <><center><h1 className="m-5">Sorry you can't download this certificate</h1></center></>}
      {renderCertificate("certificate-download-container", true)}
    </>
  );
};

export default PreviewDownloadCertificate;